// Stack of currently-open modals (topmost last), owned by Modal.jsx. Kept in
// its own module so a NON-modal surface (the docked record panel,
// live/DetailDrawer.jsx) can ask whether a dialog is open above it before
// answering Escape itself.
export const modalStack = [];

export function anyModalOpen() {
  return modalStack.length > 0;
}
